import * as React from "react"
import Notification, { NotificationLevel } from "."
import "./styles.scss"

export default class ToastNotification
extends React.Component<Props, State> {
	constructor(props: Readonly<Props>) {
		super(props)
		this.state = { closed: true, closing: false }
	}

	componentDidMount() {
		setTimeout(() => this.setState({ closed: false }), 50)
	}

	componentWillReceiveProps(nextProps: Readonly<Props>) {
		if (nextProps.symbol !== this.props.symbol && this.state.closed)
			this.setState({ closed: false })
	}

	render() {
		let className = "toast-notification"
		if (this.state.closed) className += " toast-notification-closed"

		const message = this.props.error
		? <div><p>{this.props.message}</p><p>{this.props.error.message}</p></div>
		: this.props.message

		return <div className={className}
		onTransitionEnd={e => this.handleTransitionEnd(e)}>
			<Notification
			level={this.props.level}
			message={message}
			onClickCloseButton={e => this.handleClickClose(e)} />
		</div>
	}

	private handleClickClose(e: React.SyntheticEvent<Element>): void {
		this.setState({ closed: true, closing: true })
	}

	private handleTransitionEnd(e: React.TransitionEvent<Element>): void {
		if (this.state.closing)
			this.setState({ closed: true, closing: false }, () => {
				this.props.onClose(this.props.symbol)
			})
	}
}

export interface Props {
	message: string
	symbol: Symbol
	error?: Error
	level?: NotificationLevel
	onClose(symbol: Symbol): void
}

interface State {
	closed: boolean
	closing: boolean
}



// WEBPACK FOOTER //
// ./src/component/notification/toast-notification.tsx